import { Component as ComponentContainer } from '@styles/layout';
import { TravelGuideComponent, PageTemplates } from '@model/content';
import { TravelGuideCarousel, TravelGuideList } from '@components/guides';

export const TravelGuideContainer = ({ path, tripType, guides, destination, pageType }: TravelGuideComponent) => {
  const Component = pageType === PageTemplates.LIST_PAGE ? TravelGuideList : TravelGuideCarousel;
  return (
    <ComponentContainer>
      <Component path={path} destination={destination?.display} tripType={tripType} guides={guides} />
    </ComponentContainer>
  );
};
//
